import React, { useEffect, useRef, useCallback } from "react";

const ListItem = (props) => {
  const ref = useRef(null);

  useEffect(() => {
    if (props.focus) {
      // Move element into view when it is focused
      ref.current.focus();
    }
  }, [props.focus]);

  const handleSelect = useCallback(() => {
    // setting focus to that element when it is selected
    props.setFocus(props.index);
  }, [props]);

  return (
    <li
      className={props.className}
      tabIndex={props.focus ? 0 : -1}
      role="button"
      ref={ref}
      onClick={props.onSelect}
      onKeyDown={(e) => {
        handleSelect(e);
        if (e.keyCode === 13) {
          e.preventDefault();
          props.onSelect();
        }
        e.keyCode === 9 && props.onTab();
      }}
    >
      {props.children}
    </li>
  );
};

export default ListItem;
